import React, { useContext, useEffect, useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  Box
} from '@mui/material';
import WarningAmberRoundedIcon from '@mui/icons-material/WarningAmberRounded';
import { SnackbarContext } from '../snackbar/Snackbar';

const SessionExpiredDialog = ({ open, onStay, onLeave,setOpen }) => {
  const [seconds, setSeconds] = useState(30);
  const { displaySnackbar } = useContext(SnackbarContext);

  useEffect(() => {
    if (!open) return;

    setSeconds(30); // reset timer when dialog opens
    const interval = setInterval(() => {
      setSeconds(prev => {
        if (prev <= 1) {
          clearInterval(interval);
          displaySnackbar('error', "Your session has expired. Please log in again.");
          setOpen(false)
          onLeave(); // auto logout
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(interval); // cleanup on unmount/close
  }, [open, onLeave]);

  return (
    <Dialog open={open} maxWidth='sm'
      sx={{ '& .MuiPaper-root': { borderRadius: '16px', height: '200px' } }}>
      <DialogTitle sx={{ display: 'flex', gap: '15px', alignItems: 'center' }}>
        <WarningAmberRoundedIcon color='warning' sx={{ fontSize: "35px" }} />
        Session Expired
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          Your session has expired. Do you want to stay signed in?
          <br />
          You will be logged out in <strong>{seconds} sec</strong>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%', margin: '0px 10px 10px 10px' }}>
          <Box className='add-button-container' sx={{ gap: '15px' }}>
            <Button
              disableRipple
              className='global-cancel-button'
              onClick={onLeave}>
              Logout
            </Button>
          </Box>
          <Box className='add-button-container' sx={{ gap: '15px' }}>
            <Button className='add-button'
              variant="contained"
              onClick={onStay}>
              Stay
            </Button>
          </Box>
        </Box>
      </DialogActions>
    </Dialog>
  );
};

export default SessionExpiredDialog;
